module.exports = __webpack_public_path__ + "media/images/teaser-icon-shield-border-0d90f2a8c48c757fb44cb05b7d7f8d6d.svg";